import { TemplateEnum } from "../../types/templateEnum";
import StackedBarChart from "./stackedBarChart";
import React from "react";
import { SpecialChartResponseType } from "../../types/specialChartType";

type ChartComponentProps = {
  readonly allData: SpecialChartResponseType;
};

type ChartMappingType = {
  [key in TemplateEnum]?: React.FC<ChartComponentProps>;
};

export const specialChartsMapping: ChartMappingType = {
  LIMITED_RANGING: StackedBarChart,
  RANGING: StackedBarChart,
};
